// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__7cGIq","slide__info":"Slide_slide__info__sn3W+","slide__info_right":"Slide_slide__info_right__CD67t","slide__actions":"Slide_slide__actions__+MlHo"};